import { render, staticRenderFns } from "./HueKoy.vue?vue&type=template&id=470c2428&scoped=true&"
import script from "./HueKoy.vue?vue&type=script&lang=js&"
export * from "./HueKoy.vue?vue&type=script&lang=js&"
import style0 from "./HueKoy.vue?vue&type=style&index=0&id=470c2428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c2428",
  null
  
)

export default component.exports